import React, { useMemo } from 'react';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';

import * as styles from './Image.module.scss';

function Image({
  className,
  classImage,
  alt = 'image',
  src = {},
  lazy = true,
  mobileBreakpoint = '600',
  tabletBreakpoint = '960',
  ...props
}) {
  const srcPointers = useMemo(
    () => [
      [src.mobile_webp, src.mobile_webp_2x, src.mobile, src.mobile_2x, mobileBreakpoint],
      [src.tablet_webp, src.tablet_webp_2x, src.tablet, src.tablet_2x, tabletBreakpoint],
      [src.desktop_webp, src.desktop_webp_2x, src.desktop, src.desktop_2x],
    ],
    [src],
  );

  return !isEmpty(src) ? (
    <picture className={className} {...props}>
      {srcPointers.map((img, i) => (
        <React.Fragment key={i}>
          {img[0] && (
            <source {...getSrcSet(lazy, img[0], img[1])} {...getMedia(img[4])} type="image/webp" />
          )}
          {img[2] && <source {...getSrcSet(lazy, img[2], img[3])} {...getMedia(img[4])} />}
        </React.Fragment>
      ))}
      <img
        className={cn(classImage, styles.img, lazy && 'lazyload')}
        alt={alt}
        {...getSrc(lazy, src.desktop)}
      />
    </picture>
  ) : null;
}

function buildSrcSetValue(src, src2x) {
  const baseSrc = `${src} 1x`;
  const retinaSrc = src2x ? `, ${src2x} 2x` : '';
  return baseSrc + retinaSrc;
}

function getSrcSet(lazy, src, src2x) {
  const srcSetValue = buildSrcSetValue(src, src2x);

  if (lazy) {
    return {
      'data-srcset': srcSetValue,
    };
  }

  return {
    srcSet: srcSetValue,
  };
}

function getSrc(lazy, src) {
  if (lazy) {
    return {
      'data-src': src,
    };
  }

  return { src };
}

function getMedia(viewport) {
  if (viewport) {
    return {
      media: `(max-width: ${viewport}px)`,
    };
  }
}

export default React.memo(Image);
